export const NARROW_LAYOUT_THRESHOLD = 900;
